import { useCallback, useMemo, useState } from "react";
import { validateEmail } from "utils/validators";
import {ROUTES} from "../../../constants/routes";
import {OpenAPI} from "../../../api/client";

const useSignIn = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [validFieldErrors, setValidFieldErrors] = useState<string[]>([]);
  const [errorText, setErrorText] = useState<string>("");

  const handleEmailChange = useCallback((value: string) => {
    setEmail(value);
    setValidFieldErrors((prev) =>
      prev.filter((error: string) => error !== "email")
    );
    setErrorText("");
  }, []);

  const handlePasswordChange = useCallback((value: string) => {
    setPassword(value);
    setValidFieldErrors((prev) =>
      prev.filter((error: string) => error !== "password")
    );
  }, []);

  const checkFieldValidation = useCallback(
    (value: string, key: string) => () => {
      if (!value) {
        setValidFieldErrors((prevErrors) =>
          prevErrors.includes(key) ? prevErrors : [...prevErrors, key]
        );
      } else if (key === "email" && !validateEmail(value)) {
        setValidFieldErrors((prevErrors) =>
          prevErrors.includes(key) ? prevErrors : [...prevErrors, key]
        );

        setErrorText("Please enter a valid email address");
      }
    },
    []
  );

  const checkFieldsValidation = useCallback(
    (values: { [key: string]: string }) =>
      Object.entries(values).forEach(([key, value]) => {
        checkFieldValidation(value, key)();
      }),
    [checkFieldValidation]
  );

  const formData = useMemo(() => {
    const values = {
      email,
      password,
    };

    return {
      values,
      isValid: Object.values(values).every((el) => el) && validateEmail(email),
    };
  }, [email, password]);

  const handleFormClear = useCallback(() => {
    setEmail("");
    setPassword("");
  }, []);

  const handleSubmit = useCallback(() => {
    const clientRedirectUri = encodeURIComponent(window.location.origin + ROUTES.authCallback)
    const baseUrl = (window as any).aka_env?.API_URL || OpenAPI.BASE;
    window.location.href = baseUrl +'/v1/login'+'?redirect_uri=' + clientRedirectUri;
  }, []);


  return {
    email,
    password,
    loading,
    validFieldErrors,
    errorText,
    handleEmailChange,
    handlePasswordChange,
    handleSubmit,
    checkFieldValidation,
  };
};

export default useSignIn;
